import { render, staticRenderFns } from "./SwitchIcon.vue?vue&type=template&id=e411d292&scoped=true"
import script from "./SwitchIcon.vue?vue&type=script&lang=js"
export * from "./SwitchIcon.vue?vue&type=script&lang=js"
import style0 from "./SwitchIcon.vue?vue&type=style&index=0&id=e411d292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e411d292",
  null
  
)

export default component.exports